const getExtensionValueReference = (resource, fhirUrl) =>
	resource?.extension?.find(elem => elem.url === fhirUrl)?.valueAttachment || null;

export default getExtensionValueReference;
